<template>
  <div>
    <el-dialog :visible="visible" title="营销记录" width="960px" :before-close="handleClose">
      <div class="search-box">
        <el-form ref="formSearch" :inline="true" :model="form" label-width="100px">
          <el-form-item label="统计时间">
             <el-select size="small" v-model="timeType" @change="switchType">
              <el-option v-for="(item, index) in statisticalTime" :key="index" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form.sendTimeStart"
              type="datetime"
              placeholder="开始日期"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px;margin-left:10px;font-size:12px"
              class="time1"
              :clearable="false"
              @change="moneyPayTimeChange"
            ></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form.sendTimeEnd"
              type="datetime"
              placeholder="结束日期"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px;font-size:12px"
              class="time2"
              :clearable="false"
              @change="moneyPayTimeChange"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
            <img src="@/assets/images/select_date.svg" alt="" class="date_icon2">
          </div>        
          <div class="button-group">
            <el-button size="small" class="search" type="primary"  @click="submitForm('formSearch')"> 
                  <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;"></i> 查询
              </el-button>
              <el-button size="small" class="reset" type="primary"  @click="resetForm">重置</el-button>
          </div>
        </el-form>
        <!-- <div></div> -->
        <!-- <p class="red-tip">注意：短信扣费先按照提交条数预扣相应短信条数，余额会减少，发送后2~5天会按照京东实际返回的短信状态报告成功扣费，短信条数多退少补</p> -->
        <div class="table-box">
          <el-table ref="table" v-loading="tableLoading" :data="tableData" tooltip-effect="light" style="width: 100%; border: 1px solid #eee">
                      <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
            <el-table-column label="发送时间" prop="sendTime" width="200px"></el-table-column>
            <el-table-column label="发送人数" prop="crowdSize"></el-table-column>
            <el-table-column label="计费条数" prop="perFeeCount"></el-table-column>
            <el-table-column label="短信量" prop="feeCount"></el-table-column>
            <!-- <el-table-column label="实际发送人数" prop="realSendNum">
              <template slot="header">
                <span>实际发送人数</span>
                 <el-tooltip
                    class="item"
                    effect="light"
                    content="实际发送人数：短信发送完成后京东会返回实际发送人数"
                  >
                    <span class="question_icon">?</span>
                  </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="实际扣费条数" prop="feeCount">
              <template slot="header">
                <span>实际扣费条数</span>
                 <el-tooltip
                    class="item"
                    effect="light"
                    content="实际扣费条数京东官方会在发送后2天返回，发送后未返回显示--，发送失败显示0，已发送会显示具体扣费条数；"
                  >
                    <span class="question_icon">?</span>
                  </el-tooltip>
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="退回条数" prop="backSendNum">
               <template slot="header">
                <span>退回条数</span>
                 <el-tooltip
                    class="item"
                    effect="light"
                    content="根据京东官方通道实际返回的状态报告结算，状态报告失败的会退回相应条数；"
                  >
                    <span class="question_icon">?</span>
                  </el-tooltip>
              </template>
            </el-table-column> -->
          </el-table>
           <!-- 分页器 -->
        <div>
          <el-pagination
              background
              style="text-align: right; margin-top: 20px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.current"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="form.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="crowdTotal"
            ></el-pagination>
        </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTaskPage } from '@/api/marketing/autoMarketingO'
export default {
  /** 短信记录弹窗 */
  name: 'sms-record',
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false
    // },
    propId: {
      type: String,
      default: "",
    },
    propActivityStartTime: {
      type: String,
      default: "",
    },
    isAutoMarketOfficalModule: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: true,
      timeType: '7',
      form: {
        sendTimeStart: '',
        sendTimeEnd: '',
        id: '',
        size: 10,
        current: 1	
      },
      statisticalTime: [
        {
          label: '自定义',
          value: ''
        },
         {
          label: '近7天',
          value: '7'
        },
         {
          label: '近15天',
          value: '15'
        },
         {
          label: '近30天',
          value: '30'
        }
      ],
      tableData: [],
      tableLoading: false,
      crowdTotal: 0
    }
  },
  mounted() {
    this.form.id = this.propId;
    this.switchType(7); 
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.tableLoading = true;
      console.log('this.form', this.form)
      getTaskPage(this.form).then(res => {
        this.tableLoading = false;
        if (res.data.code == 0) {
          this.$message.error(res.data.message)
          this.tableData = [];
          this.crowdTotal = 0;
          return
        }
        // console.log(res)
        this.tableData = res.data.records;
        this.crowdTotal = res.data.total;
      })
    },
    switchType(val) {
      if(this.isAutoMarketOfficalModule){
        var endTime = new Date(this.addDayCount(0)).getTime();
        var startTime = new Date(this.propActivityStartTime);
        startTime.setDate(startTime.getDate() + Number(val));
        this.form.sendTimeStart = this.ToStrfommat(endTime).substr(0, 10) + ' 00:00:00';
        this.form.sendTimeEnd = this.ToStrfommat(startTime).substr(0, 10) + ' 23:59:59';
      }else {
        var endTime = new Date(this.addDayCount(1)).getTime();
        var startTime = new Date();
        startTime.setDate(startTime.getDate() - val);
        this.form.sendTimeStart = this.ToStrfommat(startTime).substr(0, 10) + ' 00:00:00';
        this.form.sendTimeEnd = this.ToStrfommat(endTime).substr(0, 10) + ' 23:59:59';
      }
    },

    addDayCount(addDayCount) {
      let date = this.isAutoMarketOfficalModule
        ? new Date(this.propActivityStartTime)
        : new Date();
      date.setDate(date.getDate() - addDayCount);
      let y = date.getFullYear()
      let m = this.editDate(date.getMonth() + 1) // 获取当前月份的日期
      let d = this.editDate(date.getDate())
      const h = this.editDate(date.getHours())
      const mm = this.editDate(date.getMinutes())
      const ss = this.editDate(date.getSeconds())
      return `${y}-${m}-${d} ${h}:${mm}:${ss}`
    },

    editDate(date) {
      if (date > 9) {
          return date
      } else {
          return "0" + date
      }
    },

    handleClose() {
      console.log('onClose')
      this.$emit('onClose');
    },

    clearTime() {
      this.form.sendTimeStart = '';
      this.form.sendTimeEnd = '';
    },
    moneyPayTimeChange() {
      this.timeType = '';
    },
    submitForm() {  
      this.getDataList();
    },
    resetForm() {
      this.form = {
        sendTimeStart: '',
        sendTimeEnd: '',
        id: this.propId,
        size: 10,
        current: 1	
      }
      this.timeType = '7';
      this.switchType(7); 
      this.getDataList();
    },
    handleSizeChange(size) {
      this.form.size = size;
      this.getDataList();
    },
    handleCurrentChange(current) {
      this.form.current = current;
      this.getDataList();
    },
  }
}
</script>

<style lang="scss" scoped>
.red-tip{
  color: red;
  margin-bottom: 15px;
}
.question_icon {
  margin-left: 5px;
  width: 14px;
  height: 14px;
  color: #e67474 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #e67474;
  font-size: 12px !important;
  font-weight: normal !important;
}
.search-box{
  .el-input, .el-select{
    width: 136px;
  }
  .button-group{
    display: inline-block;
    margin-left: 20px;
  }
}
</style>
